import { render, staticRenderFns } from "./ContractEditTabInformation.vue?vue&type=template&id=06c94882&scoped=true&"
import script from "./ContractEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ContractEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContractEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c94882",
  null
  
)

export default component.exports